import styled from 'styled-components';

export const ImageWrapper = styled('img')`
  width: 100%;
`;
